<template>
  <NewHouseLayout :breadcrumbs="[{ name: '业务详情' }]">
    <div class="nh-page">
      <div class="nh-card" v-loading="loading">
        <h3 class="nh-page-title">业务详情</h3>

        <!-- 购房信息 -->
        <section v-if="detail?.gfxx" class="nh-section">
          <h4 class="nh-section-title">
            <span class="bar"></span>购房信息
          </h4>
          <div class="nh-info-grid">
            <div class="nh-info-cell">
              <span class="label">申请人姓名</span>
              <span class="value">{{ detail.gfxx.sqrxm || '—' }}</span>
            </div>
            <div class="nh-info-cell">
              <span class="label">项目名称</span>
              <span class="value">{{ detail.gfxx.xmmc || '—' }}</span>
            </div>
            <div class="nh-info-cell">
              <span class="label">证件号码</span>
              <span class="value">{{ detail.gfxx.zjhm || '—' }}</span>
            </div>
            <div class="nh-info-cell">
              <span class="label">房屋坐落</span>
              <span class="value">{{ detail.gfxx.fwzl || '—' }}</span>
            </div>
            <div class="nh-info-cell">
              <span class="label">联系电话</span>
              <span class="value">{{ detail.gfxx.lxdh || '—' }}</span>
            </div>
            <div class="nh-info-cell">
              <span class="label">房屋性质</span>
              <span class="value">{{ detail.gfxx.fwxz || '—' }}</span>
            </div>
          </div>
        </section>

        <!-- 缴纳契税（接口暂无对应字段，保留占位） -->
        <section v-if="detail?.deed" class="nh-section">
          <h4 class="nh-section-title">
            <span class="bar"></span>缴纳契税
          </h4>
          <el-button type="danger" class="nh-pay-btn">立即缴纳</el-button>
          <div class="nh-info-grid">
            <div class="nh-info-cell">
              <span class="label">计税依据</span>
              <span class="value">{{ detail.deed.basis || '—' }}</span>
            </div>
            <div class="nh-info-cell">
              <span class="label">应缴金额</span>
              <span class="value highlight">{{ detail.deed.amount || '—' }}</span>
            </div>
            <div class="nh-info-cell">
              <span class="label">契税税率</span>
              <span class="value">{{ detail.deed.rate || '—' }}</span>
            </div>
          </div>
        </section>

        <!-- 住宅专项维修资金缴纳 -->
        <section v-if="detail?.wxzj" class="nh-section">
          <h4 class="nh-section-title">
            <span class="bar"></span>住宅专项维修资金缴纳
          </h4>
          <el-button
            v-if="detail.wxzj.jfzt !== '1'"
            type="danger"
            class="nh-pay-btn"
            :loading="paying"
            @click="handlePayFund"
          >
            去缴纳
          </el-button>
          <span v-else class="nh-paid-tag">已缴费</span>
          <div class="nh-info-grid">
            <div class="nh-info-cell">
              <span class="label">建筑面积</span>
              <span class="value">{{ detail.wxzj.jzmj || '—' }} ㎡</span>
            </div>
            <div class="nh-info-cell">
              <span class="label">应缴金额</span>
              <span class="value highlight">
                {{ detail.wxzj.yswxzjyjk || '—' }} 元
              </span>
            </div>
            <div class="nh-info-cell">
              <span class="label">计费标准</span>
              <span class="value">{{ detail.wxzj.lbmc || '—' }}</span>
            </div>
            <div class="nh-info-cell" v-if="detail.wxzj.jkid">
              <span class="label">缴款识别码</span>
              <span class="value">{{ detail.wxzj.jkid }}</span>
            </div>
          </div>
        </section>

        <!-- 网签合同备案（文件实际在 gfxx 里） -->
        <section v-if="detail?.gfxx && (detail.gfxx.wqht || detail.gfxx.bazm)" class="nh-section">
          <h4 class="nh-section-title">
            <span class="bar"></span>网签合同备案
          </h4>
          <div class="nh-info-grid">
            <div class="nh-info-cell">
              <span class="label">网签合同</span>
              <span class="value">
                <a
                  v-if="detail.gfxx.wqht"
                  class="nh-link"
                  @click="handleFilePreview(detail.gfxx.wqht)"
                >查看</a>
                <span v-else>—</span>
              </span>
            </div>
            <div class="nh-info-cell">
              <span class="label">备案证明</span>
              <span class="value">
                <a
                  v-if="detail.gfxx.bazm"
                  class="nh-link"
                  @click="handleFilePreview(detail.gfxx.bazm)"
                >查看</a>
                <span v-else>—</span>
              </span>
            </div>
          </div>
        </section>

        <!-- 实测绘成果：模块始终显示，文件按 fcfht 数组渲染（无数据显示"-"）-->
        <section v-if="detail?.fcfht !== undefined" class="nh-section">
          <h4 class="nh-section-title">
            <span class="bar"></span>实测绘成果
          </h4>
          <div class="nh-info-grid">
            <template v-if="detail.fcfht.length">
              <div
                v-for="(f, i) in detail.fcfht"
                :key="f.id || i"
                class="nh-info-cell"
              >
                <span class="label">{{ f.type || '分层分户图' }}{{ detail.fcfht.length > 1 ? i + 1 : '' }}</span>
                <span class="value">
                  <a
                    v-if="f.filePath"
                    class="nh-link"
                    @click="handleFilePreview(f.filePath)"
                  >查看</a>
                  <span v-else>—</span>
                </span>
              </div>
            </template>
            <div v-else class="nh-info-cell">
              <span class="label">分层分户图</span>
              <span class="value">—</span>
            </div>
          </div>
        </section>

        <!-- 电表过户 -->
        <section v-if="detail?.gdqk" class="nh-section">
          <h4 class="nh-section-title">
            <span class="bar"></span>电表过户
          </h4>
          <div class="nh-info-grid">
            <div class="nh-info-cell">
              <span class="label">电表户号</span>
              <span class="value">{{ detail.gdqk.gd_hh || '—' }}</span>
            </div>
          </div>
        </section>

        <!-- 水表过户 -->
        <section v-if="detail?.gsqk" class="nh-section">
          <h4 class="nh-section-title">
            <span class="bar"></span>水表过户
          </h4>
          <div class="nh-info-grid">
            <div class="nh-info-cell">
              <span class="label">水表户号</span>
              <span class="value">{{ detail.gsqk.gs_hh || '—' }}</span>
            </div>
            <div class="nh-info-cell">
              <span class="label">是否办理过户</span>
              <span class="value">
                <el-radio-group v-model="gsSfblgh" size="small">
                  <el-radio-button label="1">是</el-radio-button>
                  <el-radio-button label="0">否</el-radio-button>
                </el-radio-group>
              </span>
            </div>
          </div>
        </section>

        <!-- 天然气开户 -->
        <section v-if="detail?.gqqk" class="nh-section">
          <h4 class="nh-section-title">
            <span class="bar"></span>天然气开户
          </h4>
          <div class="nh-info-grid">
            <div class="nh-info-cell">
              <span class="label">燃气户号</span>
              <span class="value">{{ detail.gqqk.gq_hh || '—' }}</span>
            </div>
            <div class="nh-info-cell">
              <span class="label">是否办理开户</span>
              <span class="value">
                <el-radio-group v-model="gqSfblgh" size="small">
                  <el-radio-button label="1">是</el-radio-button>
                  <el-radio-button label="0">否</el-radio-button>
                </el-radio-group>
              </span>
            </div>
          </div>
        </section>

        <!-- 不动产信息（接口字段 bdcdj） -->
        <section v-if="detail?.bdcdj" class="nh-section">
          <h4 class="nh-section-title">
            <span class="bar"></span>不动产信息
          </h4>
          <div class="nh-info-grid">
            <div class="nh-info-cell">
              <span class="label">税票号码</span>
              <span class="value">
                <el-input
                  v-model="wsbh"
                  size="small"
                  class="nh-input"
                  placeholder="请输入税票号码"
                />
              </span>
            </div>
            <div class="nh-info-cell">
              <span class="label">申请编号</span>
              <span class="value">{{ detail.bdcdj.bdc_sqbh || '—' }}</span>
            </div>
            <div class="nh-info-cell">
              <span class="label">办理状态</span>
              <span class="value">
                {{ detail.bdcdj.bdc_status !== undefined && detail.bdcdj.bdc_status !== null && detail.bdcdj.bdc_status !== '' ? formatBdcStatus(detail.bdcdj.bdc_status) : '—' }}
              </span>
            </div>
            <div class="nh-info-cell">
              <span class="label">业务消息</span>
              <span class="value">{{ detail.bdcdj.bdc_msg || '—' }}</span>
            </div>
          </div>
        </section>

        <!-- 相关资料上传（按接口 xgzl 动态渲染） -->
        <section v-if="detail?.xgzl?.length" class="nh-section">
          <h4 class="nh-section-title">
            <span class="bar"></span>相关资料上传
          </h4>
          <div
            v-for="item in detail.xgzl"
            :key="item.type"
            class="nh-uploader"
          >
            <p class="nh-uploader-title">
              <span class="required">*</span>{{ item.title }}
            </p>
            <p class="nh-uploader-tip">
              支持 png, jpg, jpeg, bmp, pdf, xls, xlsx, doc, docx 格式
            </p>
            <div class="nh-uploader-list">
              <div
                v-for="f in getUploadedFiles(item.type)"
                :key="f.id"
                class="nh-uploaded"
              >
                <div
                  class="nh-uploaded-thumb"
                  @click="handlePreview(f)"
                >
                  <span class="file-icon">{{ getFileIcon(f) }}</span>
                  <span class="file-id">#{{ f.id }}</span>
                  <span class="file-hint">点击预览</span>
                </div>
                <el-button
                  class="nh-remove-btn"
                  size="small"
                  :loading="removingId === f.id"
                  @click="handleRemoveFile(f.id)"
                >
                  删除
                </el-button>
              </div>
              <el-upload
                class="nh-uploader-trigger"
                :show-file-list="false"
                :auto-upload="false"
                accept=".png,.jpg,.jpeg,.bmp,.pdf,.xls,.xlsx,.doc,.docx"
                :on-change="(file) => handleFileChange(item.type, file)"
              >
                <div
                  class="nh-upload-slot"
                  :class="{ 'is-loading': uploading === item.type }"
                >
                  <template v-if="uploading === item.type">
                    <span class="loading-text">上传中…</span>
                  </template>
                  <template v-else>
                    <span class="plus">+</span>
                    <span>本地文件</span>
                  </template>
                </div>
              </el-upload>
            </div>
          </div>
        </section>

        <!-- 空态：detail 没加载到 -->
        <el-empty
          v-if="!loading && !detail"
          description="业务详情加载失败"
        />
      </div>

      <div class="nh-footer" v-if="detail">
        <el-button
          size="large"
          class="nh-btn nh-btn-prev"
          @click="handlePrev"
        >
          上一步
        </el-button>
        <el-button
          type="danger"
          size="large"
          class="nh-btn nh-btn-submit"
          @click="handleSubmit"
        >
          确认提交
        </el-button>
      </div>
    </div>

    <!-- 缴款二维码弹窗 -->
    <el-dialog
      v-model="payDialogVisible"
      title="维修资金缴纳"
      width="360px"
      :close-on-click-modal="false"
      center
    >
      <div class="nh-pay-dialog">
        <p class="nh-pay-tip">
          请使用 <strong>微信</strong> 扫一扫下方二维码完成支付
        </p>
        <div class="nh-pay-qr">
          <img
            v-if="payUrl"
            :src="payQrUrl(payUrl)"
            alt="缴款二维码"
            @load="onQrLoad"
            @error="onQrError"
          />
        </div>
        <p class="nh-pay-amount">
          应缴金额：
          <span class="highlight">
            {{ detail?.wxzj?.yswxzjyjk || '—' }} 元
          </span>
        </p>
      </div>
      <template #footer>
        <el-button type="danger" @click="payDialogVisible = false">
          我已支付
        </el-button>
      </template>
    </el-dialog>
  </NewHouseLayout>
</template>

<script setup>
import NewHouseLayout from './layout.vue';
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import qrcode from 'qrcode-generator';
import {
  getBusinessDetailRe,
  getMaintenanceFundRe,
  uploadFileRe,
  removeFileRe,
  updateBusinessRe,
} from '@/api/newHouse';
import { decodeData } from '@/utils/decodeData';

const route = useRoute();
const router = useRouter();

const detail = ref(null);
const loading = ref(false);
// 当前正在上传的材料 type（用于按钮 loading 状态）
const uploading = ref('');
// 当前正在删除的文件 id
const removingId = ref('');
// 缴款码弹窗
const payUrl = ref('');
const payDialogVisible = ref(false);
// 缴款码接口 loading
const paying = ref(false);

// 可编辑字段
const wsbh = ref(''); // 不动产信息-税票号码
const gsSfblgh = ref(''); // 水表过户-是否办理过户
const gqSfblgh = ref(''); // 天然气开户-是否办理开户

// 二维码：本地用 qrcode-generator 生成 SVG dataURL，无外部依赖
const payQrUrl = (url) => {
  if (!url) return '';
  try {
    const qr = qrcode(0, 'M');
    qr.addData(url);
    qr.make();
    const svg = qr.createSvgTag({
      cellSize: 6,
      margin: 2,
      scalable: true,
    });
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  } catch (e) {
    return '';
  }
};

// 根据材料 type 找到已上传的附件
const getUploadedFiles = (type) => {
  if (!detail.value?.fj) return [];
  return detail.value.fj.filter((f) => f.type === type);
};

// 不动产办理状态 0/1/2 → 文案
const formatBdcStatus = (s) => {
  if (s === '0' || s === 0) return '未开始';
  if (s === '1' || s === 1) return '办理中';
  if (s === '2' || s === 2) return '已办结';
  return s || '—';
};

// 加载业务详情
const fetchDetail = async () => {
  const ywId = route.query.ywId;
  if (!ywId) return;
  loading.value = true;
  try {
    const res = await getBusinessDetailRe(ywId);
    const decoded = decodeData(res?.data);
    detail.value = decoded?.data || decoded || null;
    // 初始化可编辑字段
    wsbh.value = detail.value?.bdcdj?.wsbh || '';
    gsSfblgh.value = detail.value?.gsqk?.sfblgh || '';
    gqSfblgh.value = detail.value?.gqqk?.sfblgh || '';
  } catch (e) {
    detail.value = null;
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  fetchDetail();
});

// 已上传文件 URL 前缀（后端 file_path 是相对路径，要拼上访问前缀）
const FILE_BASE_URL = 'https://admin.wnzhzj.com';

// 获取文件预览 URL
const getFileUrl = (f) => {
  if (!f?.file_path) return '';
  if (/^https?:\/\//.test(f.file_path)) return f.file_path;
  return `${FILE_BASE_URL}/${f.file_path}`;
};

// 判断文件类型用于图标
const getFileIcon = (f) => {
  const path = f?.file_path || '';
  if (/\.(png|jpg|jpeg|bmp|gif|webp)$/i.test(path)) return '🖼️';
  if (/\.pdf$/i.test(path)) return '📕';
  if (/\.(xls|xlsx)$/i.test(path)) return '📊';
  if (/\.(doc|docx)$/i.test(path)) return '📝';
  return '📄';
};

// 预览文件
const handlePreview = (f) => {
  const url = getFileUrl(f);
  if (!url) {
    ElMessage.warning('文件地址为空');
    return;
  }
  window.open(url, '_blank');
};

// 预览路径字符串（合同备案/实测绘的文件查看走这个）
const handleFilePreview = (path) => {
  handlePreview({ file_path: path });
};

// 上传（el-upload on-change）
const handleFileChange = async (type, file) => {
  const ywId = route.query.ywId;
  if (!ywId) {
    ElMessage.warning('缺少业务 id');
    return;
  }
  if (!file?.raw) return;
  const formData = new FormData();
  formData.append('file', file.raw);
  formData.append('ywId', ywId);
  formData.append('fileFolder', type);
  formData.append('sort', '1');
  uploading.value = type;
  try {
    await uploadFileRe(formData);
    ElMessage.success('上传成功');
    fetchDetail();
  } catch (e) {
    ElMessage.error('上传失败');
  } finally {
    uploading.value = '';
  }
};

const handleRemoveFile = async (fileId) => {
  removingId.value = fileId;
  try {
    await removeFileRe(fileId);
    ElMessage.success('删除成功');
    fetchDetail();
  } catch (e) {
    ElMessage.error('删除失败');
  } finally {
    removingId.value = '';
  }
};

const onQrLoad = () => {
  // 二维码图片加载完成
};

const onQrError = () => {
  ElMessage.error('二维码加载失败，请稍后重试');
};

const handlePayFund = async () => {
  const jkid = detail.value?.wxzj?.jkid;
  if (!jkid) {
    ElMessage.warning('缺少缴款识别码');
    return;
  }
  paying.value = true;
  try {
    const res = await getMaintenanceFundRe(jkid);
    // res 已经过 newHouse 自己的 axios 拦截器，自动解包了 {code,msg,data}
    // 此时 res = {code,msg,data} 或 string(已缴费提示)
    const data = res?.data;
    // 已缴费返回 { code:1, msg:'已缴费', data:null }
    if (res?.code === 1 || data === null) {
      ElMessage.success('已缴费');
      fetchDetail();
      return;
    }
    if (typeof data === 'string' && data) {
      // data 是微信支付链接
      payUrl.value = data;
      payDialogVisible.value = true;
    } else if (data) {
      ElMessage.info(`缴款码：${data}`);
    } else {
      ElMessage.info('未获取到缴款码');
    }
  } catch (e) {
    ElMessage.error('获取缴款码失败');
  } finally {
    paying.value = false;
  }
};

const handlePrev = () => {
  router.push({
    name: 'newHouseSelectHouse',
    query: { biz: route.query.biz, houseId: route.query.houseId },
  });
};

const handleSubmit = async () => {
  // 校验必填材料：detail.xgzl 每一项都得有对应 type 的上传文件
  const required = detail.value?.xgzl || [];
  const missing = required.filter(
    (item) => getUploadedFiles(item.type).length === 0
  );
  if (missing.length > 0) {
    const names = missing.map((m) => m.title || m.type).join('、');
    ElMessage.warning(`请先上传：${names}`);
    return;
  }

  const ywId = route.query.ywId;
  if (!ywId) {
    ElMessage.error('缺少业务 id');
    return;
  }

  // 把可编辑字段回写到 detail，整包提交给后端
  const payload = JSON.parse(JSON.stringify(detail.value || {}));
  if (payload.bdcdj) payload.bdcdj.wsbh = wsbh.value;
  if (payload.gsqk) payload.gsqk.sfblgh = gsSfblgh.value;
  if (payload.gqqk) payload.gqqk.sfblgh = gqSfblgh.value;

  try {
    await updateBusinessRe(ywId, payload);
    ElMessage.success('提交成功');
    router.push({ name: 'newHouseMyList' });
  } catch (e) {
    ElMessage.error('提交失败');
  }
};
</script>

<style lang="scss" scoped>
.nh-page {
  background: #ffffff;
  padding: 16px 0 24px;
  box-sizing: border-box;
}

.nh-card {
  max-width: 960px;
  margin: 0 auto;
}

.nh-page-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0d9d9;
  text-align: left;
}

.nh-section {
  position: relative;
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
  text-align: left;

  &:last-child {
    border-bottom: none;
  }
}

.nh-section-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 16px;

  .bar {
    display: inline-block;
    width: 4px;
    height: 16px;
    background: #bd1a2d;
    border-radius: 2px;
    margin-right: 8px;
  }
}

.nh-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 12px;
  column-gap: 24px;
  margin-top: 4px;
}

.nh-info-cell {
  display: flex;
  font-size: 14px;
  line-height: 1.8;

  .label {
    color: #888;
    min-width: 80px;
    margin-right: 12px;
  }

  .value {
    color: #2c3e50;

    &.highlight {
      color: #bd1a2d;
      font-weight: 600;
    }
  }
}

.nh-pay-btn {
  position: absolute;
  right: 0;
  top: 16px;
  background: #bd1a2d;
  border-color: #bd1a2d;
}

.nh-link {
  color: #bd1a2d;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.nh-input {
  max-width: 240px;
}

.nh-paid-tag {
  position: absolute;
  right: 0;
  top: 16px;
  font-size: 14px;
  color: #15a36b;
  background: #e6f7f0;
  border: 1px solid #b8e6d2;
  padding: 4px 12px;
  border-radius: 4px;
}

.nh-uploader {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
}

.nh-uploader-title {
  font-size: 14px;
  color: #2c3e50;
  margin: 0 0 4px;

  .required {
    color: #bd1a2d;
    margin-right: 2px;
  }
}

.nh-uploader-tip {
  font-size: 13px;
  color: #888;
  margin: 0 0 12px;
}

.nh-uploader-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.nh-uploader-trigger {
  display: inline-block;

  :deep(.el-upload) {
    display: block;
  }
}

.nh-uploaded {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #eee;
  position: relative;
  background: #fafafa;
}

.nh-uploaded-thumb {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #888;
  font-size: 11px;
  gap: 4px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #fff5f5;
  }

  .file-icon {
    font-size: 32px;
    line-height: 1;
  }

  .file-id {
    color: #aaa;
    word-break: break-all;
    text-align: center;
    padding: 0 4px;
  }

  .file-hint {
    color: #bd1a2d;
    font-size: 10px;
  }
}

.nh-remove-btn {
  position: absolute !important;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0 8px !important;
  font-size: 11px !important;
  background: rgba(255, 255, 255, 0.9) !important;
  border-color: #bd1a2d !important;
  color: #bd1a2d !important;
}

.nh-upload-slot {
  width: 100px;
  height: 100px;
  border: 1px dashed #c0c4cc;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #888;
  font-size: 12px;
  cursor: pointer;
  gap: 4px;

  &:hover {
    border-color: #bd1a2d;
    color: #bd1a2d;
  }

  &.is-loading {
    border-color: #bd1a2d;
    color: #bd1a2d;
    background: #fff5f5;
  }

  .plus {
    font-size: 20px;
  }

  .loading-text {
    font-size: 12px;
  }
}

.nh-footer {
  max-width: 1200px;
  margin: 24px auto 0;
  background: #ffffff;
  padding: 16px;
  display: flex;
  justify-content: center;
  gap: 24px;
  border-radius: 6px;
}

.nh-btn {
  width: 200px;
  height: 44px;
  font-size: 16px;
}

.nh-btn-prev {
  background: #fdecec;
  color: #bd1a2d;
  border-color: #fdecec;
}

.nh-btn-submit {
  background: #bd1a2d;
  border-color: #bd1a2d;
}

.nh-pay-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.nh-pay-tip {
  margin: 0;
  font-size: 14px;
  color: #2c3e50;
  text-align: center;

  strong {
    color: #07c160;
  }
}

.nh-pay-qr {
  width: 220px;
  height: 220px;
  border: 1px solid #f0d9d9;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;

  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}

.nh-pay-amount {
  margin: 0;
  font-size: 14px;
  color: #2c3e50;
  text-align: center;

  .highlight {
    color: #bd1a2d;
    font-weight: 600;
    font-size: 18px;
  }
}
</style>
